import { defineMessages, useIntl } from 'react-intl';
import { Box, HStack, VStack } from '@cbhq/cds-web/layout';
import { Avatar } from '@cbhq/cds-web/media/Avatar';
import { Tag } from '@cbhq/cds-web/tag/Tag';
import { Text } from '@cbhq/cds-web/typography/Text';

const messages = defineMessages({
  statusActive: {
    id: 'Team.editMemberTray.statusActive',
    defaultMessage: 'Active',
    description: 'Status label for an active team member in the edit tray',
  },
  statusInvitePending: {
    id: 'Team.editMemberTray.statusInvitePending',
    defaultMessage: 'Invite pending',
    description: 'Status label for a pending invite in the edit tray',
  },
});

export type EditMemberStatus = 'active' | 'pending';

const STATUS_TO_COLOR = {
  active: 'green',
  pending: 'yellow',
} as const;

const STATUS_TO_MESSAGE = {
  active: messages.statusActive,
  pending: messages.statusInvitePending,
} as const;

export type EditMemberTrayHeaderProps = {
  name: string;
  email: string;
  status: EditMemberStatus;
  avatarSrc?: string;
  titleId?: string;
};

export function EditMemberTrayHeader({
  name,
  email,
  status,
  avatarSrc,
  titleId,
}: EditMemberTrayHeaderProps) {
  const { formatMessage } = useIntl();

  return (
    <VStack flexGrow={1} alignItems="flex-start" gap={2} minWidth={0}>
      <HStack alignItems="flex-start" gap={2} minWidth={0}>
        <Avatar size="xl" name={name} alt={name} src={avatarSrc} shape="circle" paddingTop={0.5} />
        <VStack gap={0.25} alignItems="flex-start" minWidth={0}>
          <Text id={titleId} as="p" font="title3" overflow="truncate">
            {name}
          </Text>
          <Text as="p" font="label2" color="fgMuted" overflow="truncate">
            {email}
          </Text>
        </VStack>
      </HStack>
      <Box paddingStart={7}>
        <Tag emphasis="low" colorScheme={STATUS_TO_COLOR[status]}>
          {formatMessage(STATUS_TO_MESSAGE[status])}
        </Tag>
      </Box>
    </VStack>
  );
}
